// Componente de página para Listagem de Usuários
// Este elemento é referenciado na configuração de rotas em src/routes.js
import ListaUsuarios from '../../componentes/ListaUsuarios';


const ListagemUsuarios = () => {
    return (
        <div>
            <div className="container-fluid mt-3">
                <ListaUsuarios />
            </div>
        </div>
    );
    
}

export default ListagemUsuarios